import Picker from '../../../common/components/picker/picker';
import { resolveProject, searchProjects } from '../contexts/projects';

import '../styles/project-filter.css';

// El filtro de proyecto, una sola vez.
//
// Seis pantallas lo necesitan —repositorios, planeación, y las tres pestañas de
// desarrollo— y hasta acá cada una lo escribía de nuevo: unas con un `<select>`
// de los primeros cien proyectos, otras con el `Picker` copiado a mano. Dos
// formas del mismo filtro es como una queda sin el arreglo de la otra.
//
// BUSCA CONTRA EL SERVIDOR, no sobre una página. `GET /admin/projects` acepta
// `?q=`, así que el proyecto 137 se encuentra escribiendo su nombre — un
// `<select limit:100>` simplemente no lo tenía. Y `resolveProject` trae el
// nombre del que ya está elegido aunque quede fuera de la primera página: sin
// eso, un filtro guardado se lee `#57`, que parece un dato faltante.
//
// Vive en la feature de proyectos porque el endpoint es suyo: una pantalla que
// pide opciones no tiene por qué conocer la URL.

export default function ProjectFilter({
    value,
    onChange,
    label = 'Proyecto',
    all = 'Todos los proyectos',
    disabled,
}) {
    return (
        <label className="project-filter">
            <span className="project-filter__label">{label}</span>
            <Picker
                value={value}
                onChange={onChange}
                fetchOptions={searchProjects}
                resolveOption={resolveProject}
                cacheKey="projects"
                labelOf={project => project.name}
                subtitleOf={project => project.slug}
                placeholder={all}
                emptyLabel={all}
                disabled={disabled}
            />
        </label>
    );
}
